import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Divider } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import Header from './headers/Header';

import {
  DESKTOP_NAVIGATION_MENU_WIDTH,
  DESKTOP_NAVIGATION_MENU_RESPONSIVE_WIDTH,
  CONTAINER_WIDTH,
  MARGIN_HEADER,
  DESKTOP_CONTENT_WIDTH,
} from '../../../constants/Layout';

const useStyles = makeStyles((theme) => ({
  content: {
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
    width: CONTAINER_WIDTH,
    margin: '0 auto',
    marginTop: MARGIN_HEADER,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: `-${MARGIN_HEADER}px`,
  },
  drawer: {
    height: 'calc(100vh - 92px)',
    [theme.breakpoints.down('lg')]: {
      width: DESKTOP_NAVIGATION_MENU_RESPONSIVE_WIDTH,
    },
    width: DESKTOP_NAVIGATION_MENU_WIDTH,
    position: 'fixed',
    backgroundColor: 'rgb(245, 245, 245)',
  },
  drawerContainer: {
    padding: '44px 0 0 0',
    boxSizing: 'border-box',
    alignItems: 'center',
    justifyContent: 'center',
  },
  skeletonImg: {
    margin: 'auto',
    marginBottom: 40,
  },
  text: {
    margin: 'auto',
    marginTop: 32,
    marginBottom: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  root: {
    marginRight: 'auto',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      marginRight: '10%',
    },
    marginLeft: '35%',
    width: DESKTOP_CONTENT_WIDTH,
    height: 'calc(100vh - 92px)',
  },
  container: {
    marginTop: 44,
  },
}));

const DesktopLayoutSkeleton = () => {
  const classes = useStyles();
  return (
    <div>
      <Header />
      <main className={classes.content}>
        <Paper elevation={3} className={classes.drawer}>
          <div className={classes.drawerContainer}>
            <Skeleton
              className={classes.skeletonImg}
              variant="rect"
              width={185}
              height={185}
            />
            <Skeleton
              className={classes.text}
              variant="rect"
              width={250}
              height={40}
            />
            <Divider />
            <Skeleton variant="rect" width={'100%'} height={300} />
          </div>
        </Paper>
        <Paper elevation={0} className={classes.root}>
          <Box className={classes.container}>
            <Skeleton
              variant="rect"
              width={'100%'}
              height={40}
              className={classes.text}
            />
            <Skeleton
              variant="rect"
              width={'100%'}
              height={800}
              className={classes.text}
            />
          </Box>
        </Paper>
      </main>
    </div>
  );
};

export default DesktopLayoutSkeleton;
